// jshint strict:false, undef:false, unused:false

/*/
	Fetch Error Handler
	Stephen Ginn at Crema Design Studio
	Last Updated on 2026-06-22

	Shared helper used by fetch chains across plugins. Throws on a non-ok
	response, otherwise resolves the parsed JSON body.
/*/


function handleErrors(res) {
	if (!res.ok) throw new Error(res);
	return res.json();
}
